/* ============================================================
   BUMPER — the channel ident overlay. The visuals are a Three.js
   scene rendered by the store-owned BumpRunner into this canvas;
   the solid ident background (CSS) guarantees full coverage while
   the Three chunk loads on first use. Visibility comes from the
   store. The component holds no state — it only provides the
   callback-ref host the runner draws into.
   ============================================================ */
import { useTv } from '@/tv/context'
import styles from './Bumper.module.css'

export function Bumper() {
  const tv = useTv()
  const cls = [styles.bumper, tv.state.bumper && styles.show].filter(Boolean).join(' ')

  return (
    <div
      className={cls}
      // solid base in the channel ident so there's never a blank frame
      style={{ ['--ident' as string]: tv.current.ident }}
    >
      <canvas className={styles.canvas} ref={tv.registerBumpCanvas} />
      {/* host for the HTML/CSS now-playing overlays (the WebGL canvas is idle while one is shown) */}
      <div className={styles.overlay} ref={tv.registerBumpOverlay} />
    </div>
  )
}
